<template>
  <div class="a">
    <!-- 头部 -->
    <titled :num="4"></titled>
    <span class="apphome">
      <span class="box">
        <div class="tit">
          <div class="name">设置相关文档</div>
          <div class="right">
            <i class="el-icon-collection"></i>
            <el-button type="primary" size="mini">添加文档</el-button>
          </div>
        </div>
        <el-table :data="tableData"
          :header-cell-style="{color:'#4CA5FF',fontFamily:'MicrosoftYaHeiUI',fontSize:'16px',fontWeight:900,backgroundColor:'#fff'}"
          height="300px" style="width: 97%;margin-left: 30px;">
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column prop="date" label="名字" width="180" />
          <el-table-column prop="name" label="尺寸" width="90" />
          <el-table-column prop="address" label="类型" />
          <el-table-column prop="address" label="添加日期" width="140" />
          <el-table-column prop="address" label="类别" />
          <el-table-column prop="date" label="作者" />
          <el-table-column prop="12" label="语言" />
        </el-table>
      </span>
    </span>
  </div>
</template>
<script>
  import titled from '@/components/module/titled/titled.vue';
  export default {
    components: {
      titled
    },
    data () {
      return {
        tableData: [],
      }
    },

    mounted () {


    },
    methods: {



    }
  };
</script>

<style lang="scss" scoped>
  .box .tit .right {
    margin-left: auto;
  }

  .box .tit .right i {
    color: #4CA5FF;
    font-size: .34rem;
    margin-right: 0.2rem;
    transform: translateY(4px);
  }

  .box .tit .name {
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 700;
    font-size: .2rem;
    line-height: .3rem;
    color: #4CA5FF;
  }

  .box .tit {
    display: flex;
    align-items: center;
    padding: .4rem;
    padding-bottom: .1rem;
  }

  .apphome {
    padding: 15px;
    overflow-x: scroll;
    display: flex;
    margin-top: 1rem;
  }

  .apphome .box {
    height: calc(100vh - 140px);
    overflow: hidden;
    overflow-x: scroll;
    width: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
  }
</style>